import { render, staticRenderFns } from "./BatchUploadAttachment.vue?vue&type=template&id=72d44c03&scoped=true&"
import script from "./BatchUploadAttachment.vue?vue&type=script&lang=js&"
export * from "./BatchUploadAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d44c03",
  null
  
)

export default component.exports